/**
 * ディスプレイ種別コードを管理する
 * @module app/signage/consts/DisplayTypeCode
 */
define({
    // 災害対応状況
    DISASTER_CORRESPONDENCE: 1,
    // 避難所概況
    SHELTER_OVERVIEW: 2,
    // 個別避難所一覧
    INDIVIDUAL_SHELTER_LIST: 3,
    // 避難情報概況
    EVACUATION_INFORMATION_OVERVIEW: 4,
    // 避難情報履歴
    EVACUATION_INFORMATION_HISTORY: 5,
    // 被害情報概況
    DAMAGE_INFORMATION_OVERVIEW: 6,
    // 個別被害情報一覧
    INDIVIDUAL_DAMAGE_INFORMATION_LIST: 7,
    // 体制概況
    STRUCTURE_OVERVIEW: 8,
    // クロノロジ概況
    CHRONOLOGY_OVERVIEW: 9,
    // 個別クロノロジ一覧
    INDIVIDUAL_CHRONOLOGY_LIST: 10,
    // 気象情報
    WEATHER_INFORMATION: 11,
    // 観測状況
    OBSERVATION_OVERVIEW: 12,
    // 地震・津波
    EARTHQUAKE_TSUNAMI_OVERVIEW: 13,
    // ライフライン
    LIFELINE: 14,
    // 地図
    MAP: 15,
    // 主題図（避難・避難所）
    THEMATIC_EVACUATION: 16,
});
